export default __webpack_public_path__ + "static/media/others3.f6710121.jpg";